import config from '../views/login/config/remote_api';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
getValidationEmail: ({ idGroup, email }) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/login/validateuser/${email}`,
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },
  postValidateToken: ({ idGroup, idEmpresa, idUsuario, code }) => {
    return axios({
      method: 'post',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/login/validateToken`,
      headers: {
        'Content-Type': 'application/json',
          'idEmpresa': idEmpresa,
          'idUsuario': idUsuario
      },
      data: {
        userId: idUsuario,
        token: btoa(code),
      },
    })
  },
  getResendToken: ({ idGroup, userId }) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/login/resendToken/${userId}`,
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },
}